var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F7465F",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 .286c-1.738 0-3 1.042-3 2.474 0 1.438 1.292 2.526 3 2.526 1.738 0 3-1.062 3-2.555C5.92 1.293 4.683.286 3 .286zM.5 7.286a.51.51 0 0 0-.5.516V22.77a.51.51 0 0 0 .5.516h5a.51.51 0 0 0 .5-.516V7.802a.51.51 0 0 0-.5-.516h-5zM7.484 7.286c-.266 0-.484.232-.484.516V22.77c0 .284.218.516.484.516h4.355c.267 0 .484-.231.484-.516v-8c0-1.224.88-2.22 2.003-2.313.058-.01.116-.01.174-.01.058 0 .116 0 .174.01 1.122.093 2.003 1.09 2.003 2.313v8c0 .285.217.516.484.516h4.355c.266 0 .484-.232.484-.516v-8.775c0-3.339-1.68-6.71-5.425-6.71-1.703 0-2.99.703-3.769 1.286v-.77c0-.283-.217-.515-.483-.515h-4.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.7dfefc626d5aec30c9f186c16e66aae9.svg";
export { ForwardRef as ReactComponent };